export const APP_PATH = {
  business: '',
  emailVerified: 'verification',
  applicationSubmitted: 'application-submitted',
  miscellaneous: 'miscellaneous',
  achPaymentGuide: 'ach-payment-guidelines',
  mfaGuide: 'mfa-guide',
  wildcard: '**',
};
